import { useState, useCallback } from "react";

export const useDragAndDrop = (onFileDrop) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const [dragCounter, setDragCounter] = useState(0);

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter((prev) => {
      const newCounter = prev + 1;
      if (newCounter === 1) {
        setIsDragOver(true);
      }
      return newCounter;
    });
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter((prev) => {
      const newCounter = prev - 1;
      if (newCounter === 0) {
        setIsDragOver(false);
      }
      return newCounter;
    });
  }, []);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    // Ensure drop effect is set
    e.dataTransfer.dropEffect = "copy";
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragOver(false);
      setDragCounter(0);

      const files = e.dataTransfer.files;

      if (files && files.length > 0) {
        const file = files[0];

        // Validate it's an image
        if (file.type.startsWith("image/")) {
          // Create a synthetic event to match the file input handler
          const syntheticEvent = {
            target: {
              files: [file],
            },
          };

          onFileDrop(syntheticEvent);
        }
      }
    },
    [onFileDrop]
  );

  const dragProps = {
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop,
  };

  return {
    isDragOver,
    dragProps,
  };
};
